import { OKTA_CONFIG } from "../services/constants";
const config = OKTA_CONFIG;

let login = {
  render: async () => {
    let view = /*html*/ `
        <div id="container" class="container-fluid">
          <div class="row text-center">
            <div class="col"><h1>Redirecting to login ...<span></h1></div>
          </div>
          <div id="token" class="hidden">
              <h2>Access Token</h2>
              <div id="access_token" class="code"></div>
          </div>
          <div id="error" class="hidden">
              <h2>Error</h2>
              <div id="error_details" class="code"></div>
          </div>
        </div>
    `;
    return view;
  },
  after_render: async () => {
    // Create and store a random "state" value
    var state = generateRandomString();
    localStorage.setItem("pkce_state", state);

    // Create and store a new PKCE code_verifier (the plaintext random secret)
    var code_verifier = generateRandomString();
    localStorage.setItem("pkce_code_verifier", code_verifier);

    // Hash and base64-urlencode the secret to use as the challenge
    var code_challenge = await pkceChallengeFromVerifier(code_verifier);

    // Build the authorization URL
    var url =
      config.authorization_endpoint +
      "?response_type=code" +
      "&client_id=" +
      encodeURIComponent(config.client_id) +
      "&state=" +
      encodeURIComponent(state) +
      "&scope=" +
      encodeURIComponent(config.requested_scopes) +
      "&redirect_uri=" +
      encodeURIComponent(config.redirect_uri) +
      "&code_challenge=" +
      encodeURIComponent(code_challenge) +
      "&code_challenge_method=S256";
    // Redirect to the authorization server
    window.location = url;
  },
};

export default login;

//////////////////////////////////////////////////////////////////////
// GENERAL HELPER FUNCTIONS

// Make a POST request and parse the response as JSON
function sendPostRequest(url, params, success, error) {
  var request = new XMLHttpRequest();
  request.open("POST", url, true);
  request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
  request.onload = function () {
    var body = {};
    try {
      body = JSON.parse(request.response);
    } catch (e) {}

    if (request.status == 200) {
      success(request, body);
    } else {
      error(request, body);
    }
  };
  request.onerror = function () {
    error(request, {});
  };
  var body = Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
  request.send(body);
}

// Parse a query string into an object
function parseQueryString(string) {
  if (string == "") {
    return {};
  }
  var segments = string.split("&").map((s) => s.split("="));
  var queryString = {};
  segments.forEach((s) => (queryString[s[0]] = s[1]));
  return queryString;
}

//////////////////////////////////////////////////////////////////////
// PKCE HELPER FUNCTIONS

// Generate a secure random string using the browser crypto functions
function generateRandomString() {
  var array = new Uint32Array(28);
  window.crypto.getRandomValues(array);
  return Array.from(array, (dec) => ("0" + dec.toString(16)).substr(-2)).join("");
}

// Calculate the SHA256 hash of the input text.
// Returns a promise that resolves to an ArrayBuffer
function sha256(plain) {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest("SHA-256", data);
}

// Base64-urlencodes the input string
function base64urlencode(str) {
  // Convert the ArrayBuffer to string using Uint8 array to conver to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

// Return the base64-urlencoded sha256 hash for the PKCE challenge
async function pkceChallengeFromVerifier(v) {
  let hashed = await sha256(v);
  return base64urlencode(hashed);
}
